import { useState } from 'react';
import { ActionIdentifier, TimelineAnalyticsTracking, TimelineStep } from '@interfaces/models/timeline';
import PopinView from '@components/orders-sales/popin';
import { Order } from '@interfaces/models/myOrder';
import { Product } from '@interfaces/models/orderSaleProduct';
import { Popin } from '../../type';
import styles from '../../product-timeline.module.scss';
import ActionView from './action';

const ActionsView: React.FC<{
  product: Product;
  order: Order | null;
  step: TimelineStep;
  analyticsTracking: TimelineAnalyticsTracking;
}> = ({ product, order, step, analyticsTracking }) => {
  const [popin, updatePopin] = useState<Popin | null>(null);
  const { actions } = step;
  if (actions == null) {
    return <></>;
  }

  const actionsChronology = actions.actionsChronology;

  const actionList = Array.isArray(actionsChronology)
    ? actionsChronology
        .map((key: ActionIdentifier) => {
          const action = actions[key];
          if (!action || Array.isArray(action)) {
            return null;
          }
          if (
            // Pay for type safe
            key === 'cancel' ||
            key === 'confirmDelivery' ||
            key === 'contact' ||
            key === 'download' ||
            key === 'qualityControlReport' ||
            key === 'relist' ||
            key === 'report' ||
            key === 'returnForm' ||
            key === 'getPaid' ||
            key === 'shippingLabel' ||
            key === 'uploadInvoice' ||
            key === 'updateAddress' ||
            key === 'editShippingDetails'
          ) {
            action.identifier = key;
          }
          return action;
        })
        .filter((action) => action != null)
    : [];

  return (
    <div className={styles.ordersSales__mainRight__steps__step__box__actions}>
      {actionList.map((action) => {
        return (
          <ActionView
            key={action.identifier}
            updatePopin={updatePopin}
            order={order}
            product={product}
            step={step}
            action={action}
            analyticsTracking={analyticsTracking}
          />
        );
      })}
      <PopinView
        popin={popin}
        closePopin={() => updatePopin(null)}
      />
    </div>
  );
};

export default ActionsView;
